export var isPositionedToTop = function isPositionedToTop(position) {
  var _position$split = position.split(' '),
      positionMarker = _position$split[0];

  return positionMarker === 'top';
};
export var isPositionedToBottom = function isPositionedToBottom(position) {
  var _position$split2 = position.split(' '),
      positionMarker = _position$split2[0];

  return positionMarker === 'bottom';
};
export var isPositionedToRight = function isPositionedToRight(position) {
  var positionMarker = position.split(' ')[1];
  return positionMarker === 'right';
};
export var isPositionedToLeft = function isPositionedToLeft(position) {
  var positionMarker = position.split(' ')[1];
  return positionMarker === 'left';
};
export var fitsOnRight = function fitsOnRight(nodeRef, anchorRef) {
  var _nodeRef$getBoundingC = nodeRef.getBoundingClientRect(),
      nodeWidth = _nodeRef$getBoundingC.width;

  var _anchorRef$getBoundin = anchorRef.getBoundingClientRect(),
      anchorRight = _anchorRef$getBoundin.right;

  return anchorRight + nodeWidth <= window.innerWidth;
};
export var fitsOnLeft = function fitsOnLeft(nodeRef, anchorRef) {
  var _nodeRef$getBoundingC2 = nodeRef.getBoundingClientRect(),
      nodeWidth = _nodeRef$getBoundingC2.width;

  var _anchorRef$getBoundin2 = anchorRef.getBoundingClientRect(),
      anchorLeft = _anchorRef$getBoundin2.left;

  return anchorLeft - nodeWidth >= 0;
};
export var fitsOnTop = function fitsOnTop(nodeRef, anchorRef) {
  var _nodeRef$getBoundingC3 = nodeRef.getBoundingClientRect(),
      nodeHeight = _nodeRef$getBoundingC3.height;

  var _anchorRef$getBoundin3 = anchorRef.getBoundingClientRect(),
      anchorTop = _anchorRef$getBoundin3.top;

  return anchorTop - nodeHeight >= 0;
};
export var fitsOnBottom = function fitsOnBottom(nodeRef, anchorRef) {
  var _nodeRef$getBoundingC4 = nodeRef.getBoundingClientRect(),
      nodeHeight = _nodeRef$getBoundingC4.height;

  var _anchorRef$getBoundin4 = anchorRef.getBoundingClientRect(),
      anchorBottom = _anchorRef$getBoundin4.bottom;

  return anchorBottom + nodeHeight <= window.innerHeight;
};